import React, { useState } from 'react';
import Highcharts from 'highcharts';
import { Paper, Box, Divider, CircularProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import ShowMoreButton from './utils/ShowMoreButton';
import { barChartBase } from './utils/barChartBase';
import ShippedItemsChartDialog from './ShippedItemsChartDialog';
import PeriodicityButton from './utils/PeriodicityButton';
import ExportCsvButton from './utils/ExportCsvButton';
import { exportToCsv, exportToExcel } from './utils/csvExport';
import { getShippedItemsQuantities } from '../dashboardActions';

const ShippedItemsChart = ({
  shippedItemsQuantities,
  dispatchGetShippedItemsQuantities,
  loadingShippedItemsQuantities
}) => {
  const [openShippedItemDialog, setOpenShippedItemDialog] = useState(false);
  const totalShipped = shippedItemsQuantities.reduce(
    (a, b) => +a + +b.quantity,
    0
  );

  const options = {
    ...barChartBase,
    xAxis: {
      ...barChartBase.xAxis,
      categories: shippedItemsQuantities.slice(0, 8).map(s => s.description)
    },
    yAxis: {
      stackLabels: {
        ...barChartBase.yAxis.stackLabels,
        // eslint-disable-next-line
        formatter: function() {
          // eslint-disable-next-line react/no-this-in-sfc
          return `${((this.total * 100) / totalShipped).toFixed(2)} %`;
        }
      }
    },
    plotOptions: {
      series: {
        dataLabels: {
          color: '#fff'
        }
      }
    },
    series: [
      {
        name: 'Article',
        data: shippedItemsQuantities
          .slice(0, 8)
          .map(s => [s.description, s.quantity])
      }
    ]
  };

  return (
    <div>
      <ShippedItemsChartDialog
        open={openShippedItemDialog}
        handleClose={() => setOpenShippedItemDialog(false)}
      />
      <Paper
        style={{
          borderRadius: 20
        }}
      >
        <Box pt={6} pl={10} pr={10}>
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="baseline" mb={4}>
              <Box fontSize={34} color="#001C56" mr={1}>
                {totalShipped}
              </Box>
              <Box fontSize={21} color="#001C56">
                Articles expédiés
              </Box>
              <ExportCsvButton
                onClick={() => {
                  const columns = ['Article', 'Quantité', 'Pourcentage (%)'];
                  const rows = shippedItemsQuantities.map(s => [
                    s.description,
                    s.quantity,
                    totalShipped > 0
                      ? ((s.quantity * 100) / totalShipped).toFixed(2)
                      : '0'
                  ]);
                  exportToCsv('articles_expedies', columns, rows);
                }}
                onExcelClick={() => {
                  const columns = ['Article', 'Quantité', 'Pourcentage (%)'];
                  const rows = shippedItemsQuantities.map(s => [
                    s.description,
                    s.quantity,
                    totalShipped > 0
                      ? ((s.quantity * 100) / totalShipped).toFixed(2)
                      : '0'
                  ]);
                  exportToExcel('articles_expedies', columns, rows);
                }}
              />
            </Box>
            <PeriodicityButton
              onChange={({ dateFrom, dateTo }) => {
                dispatchGetShippedItemsQuantities({ dateFrom, dateTo });
              }}
            />
          </Box>
        </Box>
        {loadingShippedItemsQuantities ? (
          <Box display="flex" justifyContent="center" p={20}>
            <CircularProgress size={60} />
          </Box>
        ) : (
          <HighchartsReact highcharts={Highcharts} options={options} />
        )}
        <Divider />
        <ShowMoreButton onClick={() => setOpenShippedItemDialog(true)} />
      </Paper>
    </div>
  );
};

const mapStateToProps = state => ({
  shippedItemsQuantities: state.dashboard.shippedItemsQuantities,
  loadingShippedItemsQuantities: state.dashboard.loadingShippedItemsQuantities
});

const mapDispatchToProps = dispatch => ({
  dispatchGetShippedItemsQuantities: params =>
    dispatch(getShippedItemsQuantities(params))
});

ShippedItemsChart.propTypes = {
  shippedItemsQuantities: PropTypes.array,
  loadingShippedItemsQuantities: PropTypes.bool,
  dispatchGetShippedItemsQuantities: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippedItemsChart);
